
import { Button } from "@/components/ui/button";

interface AuthModeToggleProps {
  mode: "signin" | "signup" | "forgotPassword" | "resetPassword";
  onToggleMode: (mode: "signin" | "signup") => void;
  isProcessing: boolean;
}

export function AuthModeToggle({ mode, onToggleMode, isProcessing }: AuthModeToggleProps) {
  // Don't display toggle when in processing state or password reset flows
  if (isProcessing || mode === "forgotPassword" || mode === "resetPassword") return null;
  
  if (mode === "signin") {
    return (
      <div className="text-center mt-6">
        <p className="text-sm text-muted-foreground">
          Don't have an account?{" "}
          <Button variant="link" className="p-0" onClick={() => onToggleMode("signup")}>
            Sign up for free
          </Button>
        </p>
      </div>
    );
  }
  
  return (
    <div className="text-center mt-6">
      <p className="text-sm text-muted-foreground">
        Already have an account?{" "}
        <Button variant="link" className="p-0" onClick={() => onToggleMode("signin")}>
          Sign in
        </Button>
      </p>
    </div>
  );
}
